import styled from 'styled-components/macro';

export const CancelOptionsPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const Title = styled.p`
  text-align: center;
  font-size: 2.5rem;
  color: #001758;
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: 3.1rem;
  margin-top: 50px;
`;

export const BlueSection = styled.div`
  background-color: #edf3f7;
  padding: 15px;
`;

export const OrderLabel = styled.p``;

export const InternalNoteContainer = styled.div`
  width: 90%;
  height: 200px;
  margin: 30px auto;
`;

export const InternalNoteInput = styled.textarea`
  width: 100%;
  height: 100%;

  background-color: #ffffff;
  border: 0.1rem solid #97bbc1;
  border-radius: 1rem;
  color: #114754;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2.5rem;
  padding: 1rem;
`;

export const CancelOptionOneHeader = styled.div`
  flex: 1;
  padding: 0 8rem;
  margin-bottom: 2rem;
  text-align: center;

  @media (max-width: 1000px) {
    padding: 0 2rem;
  }
`;

export const CancelOptionFlexItem = styled.div`
  flex: ${(props) => props.flexSize};

  & textarea {
    resize: none;
  }

  & textarea:focus {
    border: 2px solid #6ca8ff;
    outline: none;
  }
`;

export const CancelButtonRow = styled.div`
  min-height: 48px;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 80%;
  margin: 20px auto;
`;

export const SubmitButton = styled.button`
  background-color: #44b1df;
  width: 13rem;
  border: 0 #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2rem;
  transition: 0.2s;

  &:hover {
    background-color: #545454;
  }
`;

export const BackButton = styled(SubmitButton)`
  background-color: #0bc495;
`;

BackButton.displayName = 'BackButton';

export const DollarInput = styled.input`
  color: ${(props) => (props.error ? '#CE3B40' : 'inherit')};

  &::placeholder {
    color: ${(props) => (props.error ? '#CE3B40' : 'inherit')};
  }
`;

DollarInput.displayName = 'DollarInput';

export const RefundAllItems = styled.span`
  color: #7f7f7f;
  text-decoration: underline;
  cursor: pointer;
  text-align: right;
`;
RefundAllItems.displayName = 'RefundAllItems';

export const DescriptionContainer = styled.div`
  width: 90%;
  margin: 0px auto;
`;

export const BlueSectionHalf = styled.div`
  display: inline-block;
  width: 50%;
  text-align: center;
`;

export const ReasonError = styled.p`
  color: red;
  margin-right: 15%;
  margin-top: 10px;
  text-align: right;
`;
